export default __webpack_public_path__ + "static/media/hook.c62a9c93.png";